<div class="panel clickable short" [routerLink]="['fleet', fleet.fleet_id]">
	<div class="heading flushright">
		<div>{{ organization ? organization.name : brand.fleetSingular}} - {{fleet.fleet_name}}</div>
		<app-health-status-indicator [item]="fleet" style="padding-right: 10px"></app-health-status-indicator>
	</div>
	<div class="content flex">
		<div class="flex-md">
			<div>
				<div><b>Number of {{brand.assetPlural}}:</b> <span class="focal">{{fleet.assets?.length}}</span></div>
				@if (!brand.fixedassets && fleet.flight_time) {
					<div><b>Total {{brand.flightTime}}:</b> <span class="focal">{{fleet.flight_time | runtime}}</span></div>
				}
			</div>
			<div class="fleet-border-left">
				<div><b>Remaining Useful Life:</b></div>
				@if (fleet.rulmin) {
					<div><span class="focal">{{fleet.rulmin | number : "1.2-2"}} hrs</span></div>
				}
				@if (!fleet.rulmin) {
					<div>No problems detected</div>
				}
			</div>
		</div>
		<div>
			<app-health-right [item]="fleet"></app-health-right>
		</div>
	</div>
</div>